export default function formatTime(minutes: number) {
    if (! minutes || minutes === 0) {
        return '-'
    }

    return Math.floor(minutes / 60).toString().padStart(2, '0') + ':' + (minutes % 60).toString().padStart(2, '0')
}
